module.exports = __webpack_public_path__ + "static/project-3c-9ce06fb811cfa47323398950ae53d3e2.png";